import { API_URL } from 'data/services/apiConstants';
import { get } from 'data/services/apiService';

export const FETCH_SIDEWALK_DATA_REQUEST = 'FETCH_SIDEWALK_DATA_REQUEST';
export const FETCH_SIDEWALK_DATA_SUCCESS = 'FETCH_SIDEWALK_DATA_SUCCESS';
export const FETCH_SIDEWALK_DATA_ERROR = 'FETCH_SIDEWALK_DATA_ERROR';
export const CLEAR_SIDEWALK_DATA = 'CLEAR_SIDEWALK_DATA';

const initialState = {
	sidewalkData: null,
	propertyData: null,
	isLoading: false,
	error: null,
};

export const fetchSidewalkData = (propertyId) => (dispatch) => {
	dispatch(fetchSidewalkDataRequest());

	// Fetch property info first
	return get({
		dispatch,
		url: `${API_URL}/api/properties/${propertyId}`,
		onSuccess: (property) => {
			// Validate coordinates exist
			if (!property.lat || !property.long) {
				return dispatch(
					fetchSidewalkDataError('Property coordinates not available')
				);
			}

			// Fetch sidewalk data
			return get({
				dispatch,
				url: `${API_URL}/api/properties/${propertyId}/sidewalk-widths`,
				onSuccess: (data) => {
					dispatch(fetchSidewalkDataSuccess(property, data));
				},
				onError: (error) => {
					dispatch(
						fetchSidewalkDataError(error.message || 'Failed to fetch sidewalk data')
					);
				},
			});
		},
		onError: (error) => {
			dispatch(
				fetchSidewalkDataError(error.message || 'Failed to fetch property data')
			);
		},
	});
};

export const clearSidewalkData = () => ({
	type: CLEAR_SIDEWALK_DATA,
});

export const fetchSidewalkDataRequest = () => ({
	type: FETCH_SIDEWALK_DATA_REQUEST,
	payload: {
		isLoading: true,
		error: null,
	},
});

export const fetchSidewalkDataSuccess = (propertyData, sidewalkData) => ({
	type: FETCH_SIDEWALK_DATA_SUCCESS,
	payload: {
		isLoading: false,
		propertyData,
		sidewalkData,
		error: null,
	},
});

export const fetchSidewalkDataError = (error) => ({
	type: FETCH_SIDEWALK_DATA_ERROR,
	payload: {
		isLoading: false,
		error,
	},
});

const sidewalkReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_SIDEWALK_DATA_REQUEST:
		case FETCH_SIDEWALK_DATA_SUCCESS:
		case FETCH_SIDEWALK_DATA_ERROR:
			return {
				...state,
				...action.payload,
			};
		case CLEAR_SIDEWALK_DATA:
			return initialState;
		default:
			return state;
	}
};

export default sidewalkReducer;
